import { Injectable } from '@angular/core';
//import { HttpErrorResponse, HttpResponse, HttpParams } from '@angular/common/http';
import { BOBCAT_API, KONTRACTOR_API } from '../common/utils/api.bobcat';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../common/utils/http.service';
import { LoaderService } from '../common/loader/loader.service';
import { Document } from '../models/document';
import { StateService } from './state/state.service';
import IAction, { Actions } from '../services/state/actions';

import { Types } from '../models/types';
import { Step } from '../models/steps';

import { Store } from '@ngrx/store';
import * as fromRoot from '../common/appstore/index';
import * as layout from '../common/appstore/actions';


import 'rxjs/add/operator/map';
import { Form } from '../models/form';


@Injectable()
export class DocumentService {

  currentdocument: Document;

  constructor(
    //private http: HttpClient,
    private httpservice: HttpService,
    private servicestate: StateService,
    private store: Store<fromRoot.AppState>
  ) { }

  saveDocument(type: string, user_id): Observable<Document> {
    return this.httpservice.post(BOBCAT_API.SAVE_DOC, { "doc_type": type, "user_id": user_id }).map((document: Document) => {
      this.store.dispatch(new layout.AddDocument(document));
      this.currentdocument = new Document(document.id, document.user_id, document.signataire_id, document.type);
      console.log('curent doc from service: ', this.currentdocument);
      return document;
    });
  }

  getListDocuments(user_id: number): Observable<Document[]> {
    return this.httpservice.post(BOBCAT_API.LIST_DOCUMENT, { "user_id": user_id }).map((documents: Document[]) => {
      this.store.dispatch(new layout.ListDocuments(documents));
      return documents;
    });
  }

  createDocument(document: Document) {
    this.currentdocument = new Document(document.id, document.user_id, document.signataire_id, document.type);
  }

  getStructureDocs() {
    //return <Observable<Docs>>this.httpservice.get(BOBCAT_API.DOCS);
    return this.httpservice.get(KONTRACTOR_API.structure.getList, null, true).map((types: { string: Types }) => {
      return types;
    });
  }


  getSteps(typeDoc: string, id: string)/*: Observable<Steps>*/ {
    /*return this.httpservice.post(BOBCAT_API.STEPS, { 'typeDoc': typeDoc }).map((steps: Steps) => {
      return steps;
    });*/
    return this.httpservice.get(KONTRACTOR_API.structure.get, [typeDoc, id], true).map((step: Step) => {
      console.log(step);
      return step;
    });
  }

  getStep(pathfile: string): Observable<Step> {
    return this.httpservice.post(BOBCAT_API.STEP, { 'fileConf': pathfile }).map((step: Step) => {
      return step;
    });
  }

  getStepForm(file) {
    return this.httpservice.get(KONTRACTOR_API.steps.get, [file], true).map((form: { sections: Array<Form> }) => {

      return form.sections;
    });
  }
  getParamsForm(file) {
    return this.httpservice.get(KONTRACTOR_API.params.getList, [file], true).map((params) => {

      return params;
    });
  }

}



// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/services/document.service.ts